module.exports = __webpack_public_path__ + "media/images/new-ui-images/blue-request-890cf25f446d8e2ed2a86d6588a0c1fc.svg";